import { IconButton } from '@eventbrite/eds-icon-button';
import { ArrowLeftChunky, ArrowRightChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { NavDirections, SlideConfig } from '../types';

export const CarouselNavigation: React.FunctionComponent<
    CarouselNavigationProps
> = (props) => {
    if (props.childrenLength === 1) {
        return null;
    }

    const classes =
        props.childrenLength <= props.slidesVisible.desktop
            ? 'simple-carousel__navigation simple-carousel__navigation--desktop-hide'
            : 'simple-carousel__navigation';

    return (
        <div className={classes}>
            <IconButton
                iconType={<ArrowLeftChunky />}
                onClick={() => props.handleClick(NavDirections.Left)}
                title={gettext('Scroll carousel left')}
                isDisabled={props.leftDisabled}
            />
            <span style={{ paddingLeft: '8px' }} />
            <IconButton
                iconType={<ArrowRightChunky />}
                onClick={() => props.handleClick(NavDirections.Right)}
                title={gettext('Scroll carousel right')}
                isDisabled={props.rightDisabled}
            />
        </div>
    );
};

interface CarouselNavigationProps {
    handleClick: (direction: NavDirections) => void;
    childrenLength: number;
    slidesVisible: SlideConfig;
    leftDisabled: boolean;
    rightDisabled: boolean;
}
